import { view, cssGenerator } from '@yola/ws-sdk';
import {
  DESKTOP_BREAKPOINT,
  TABLET_BREAKPOINT,
  MOBILE_BREAKPOINT,
} from '../../../common/constants/breakpoints';
import getPositionValues from '../../../common/helpers/get-position-values';

const { POSITION: POSITION_CLASS } = cssGenerator.constants.classNames;

const roundValue = (value) => Math.round(value * 1000000) / 1000000;

const getPositionOperations = (
  elements = [],
  breakpoint = DESKTOP_BREAKPOINT,
  isBreakpointEditingEnabled = false
) => {
  const operations = [];

  elements.forEach((element) => {
    const elementId = view.accessors.getLiveElementId(element);
    const { x, y } = getPositionValues(element, breakpoint);

    operations.push([
      view.operations.setResponsiveClass,
      [elementId, POSITION_CLASS, `${roundValue(x)}%_${roundValue(y)}%`, breakpoint],
    ]);

    if (!isBreakpointEditingEnabled) {
      // Template-authored breakpoint overrides would shadow the default value
      // on smaller screens, so they are cleared.
      operations.push(
        [view.operations.removeResponsiveClass, [elementId, POSITION_CLASS, TABLET_BREAKPOINT]],
        [view.operations.removeResponsiveClass, [elementId, POSITION_CLASS, MOBILE_BREAKPOINT]]
      );
    }
  });

  return operations;
};

export default getPositionOperations;
